
import i18n from '@/lang';
import LangSelect from '@/components/Lang.vue';
import VenuPart from '@/components/PartVenu.vue';
import AboutPart from '@/components/PartAbout.vue';
import PageFooter from '@/components/PageFooter.vue';
import SponsorPart from '@/components/PartSponsor.vue';
import ViewGallery from '@/components/PartViewGallery.vue';
import { EventBus } from '@/utils/event_bus';
import { throttle } from '@/utils/util_function';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    VenuPart,
    AboutPart,
    LangSelect,
    PageFooter,
    ViewGallery,
    SponsorPart,
  }
})
export default class extends Vue {

  hasWhiteBg = false;
  showMoveViewGallery = false;
  language = i18n.locale;

  throttle = throttle(this.handleScroll, 50);

  // beforeRouteEnter (to: any, from: any, next: any) {
  //   console.log(to,from);
  //   next(() => {
  //     console.log(from);
  //     if (from.name !== 'Home') {
  //       EventBus.$emit('scroll-to-view');
  //     }
  //   })
  // }

  mounted() {
    this.homeScroll();
    if (this.$route.params.view) {
      EventBus.$emit('scroll-to-view');
    }
    EventBus.$on('scroll-to-view', () => {
      const homeRef: any = document.querySelector('.home');
      document.body.scrollTop = homeRef.offsetHeight - 260;
      document.documentElement.scrollTop = homeRef.offsetHeight - 260;
    })
  }

  destroyed() {
    window.removeEventListener('scroll', this.throttle);
  }

  handleScroll() {
    const bgImgRef: any = this.$refs.bgImg;
    const venueRef: any = this.$refs.venue;
    const aboutRef: any = this.$refs.about;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    if(scrollTop > bgImgRef.offsetHeight - 120){
      this.hasWhiteBg = true;
    }else{
      this.hasWhiteBg = false;
    }
    if(scrollTop > bgImgRef.offsetHeight + venueRef.$el.offsetHeight + aboutRef.$el.offsetHeight - 300) {
      this.showMoveViewGallery = true;
    }
  }

  homeScroll() {
    window.addEventListener("scroll", this.throttle);
  }

}
